import isApiError from "@insite/client-framework/Common/isApiError";
import { get } from "@insite/client-framework/Services/ApiService";

export interface ApiResultModel {
    uri?: string;
    sitesSummary: SiteSummaryModel[] | null;
    properties?: {
        [key: string]: string;
    };
    pagination: {
        currentPage?: number;
        defaultPageSize?: number;
        nextPageUri?: string;
        numberOfPages?: number;
        page: number;
        pageSize?: number;
        pageSizeOptions?: number[];
        prevPageUri?: string;
        sortOptions?: string;
        sortType?: string;
        totalItemCount: number;
    };
}

export interface SiteSummaryModel {
    id: string;
    customerNumber: string;
    customerSequence: string;
    companyName: string;
    email: string;
    firstName: string;
    middleName: string;
    lastName: string;
    phone: string;
    isPrintPriceActive: boolean;
    address1: string;
    address2: string;
    city: string;
    state: string;
    postalCode: string;
    frequency: string;
    soaSubscriberCount: number;
    asnSubscriberCount: number;
    podSubscriberCount: number;
    ocSubscriberCount: number;
    isSeleted: boolean;
}

const getAllJobSitesUrl = "api/v1/orderStatusDashboard/allSitesSummary";

function generateQuery(obj: { [key: string]: any }) {
    const data: { [key: string]: any } = {};
    for (const key in obj) {
        if (obj[key]) {
            data[key] = obj[key];
        }
    }
    const queryParams = new URLSearchParams(data);
    return queryParams.toString();
}

export async function getAllJobSites(page: number, pageSize: number, customerId?: string, filter?: string) {
    const query = generateQuery({
        page,
        pageSize,
        customerId,
        filter,
    });

    try {
        const result = await get<ApiResultModel>(`${getAllJobSitesUrl}?${query}`, {}, {}, "no-store");
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}
